module.exports = __webpack_public_path__ + "media/images/weather/166_day-af072ae08fcc4a829c97840920d9fad5.png";